// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../assets/stylesheets/variables.css\"","paddedForNavbar":"_15-uIrn7gODHiOpUuDWjwC","title":"_1LX7R__2LCO0twVUPSU3Kw _2IbHD4FVxtBnbNHEUw2mS3","genericContainer":"_2ELtkcMpIJZ1yyH_kfj3I7","mobileThreshold":"575px","container":"_3Ti6TTfcgQ1qvMppG5iuNZ _15-uIrn7gODHiOpUuDWjwC","mainContent":"_2-0LK2GaNJwNnEQmjaXIhS _2ELtkcMpIJZ1yyH_kfj3I7","bulletContainer":"_35vnb0vNaa-JhGTN2bOLLd","bullet":"_2vizLZNZI6xl31mvU_2vh_","form":"_2Y8bDqTTSJWG557p9hA1FI"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/register/Register.css
// module id = 872
// module chunks = 0